import {outter_post} from 'common/js/axios-helper';
import {SystemDicApi} from "./constant/UrlMapper";

const host ="8880"
const host1 ="8885"
const host2 ="9000"


const add = (data) => {
    return outter_post(SystemDicApi.Add, data, host);
};
const list = (data) => {
    return outter_post(SystemDicApi.List, data, host);
};
const detail = (data) => {
    return outter_post(SystemDicApi.Detail, data, host);
};
const checkUnique = (data) => {
    return outter_post(SystemDicApi.CheckUnique, data, host);
};
const update = (data) => {
    return outter_post(SystemDicApi.Update, data, host);
};
const dpStatus = (data) => {
    return outter_post(SystemDicApi.DpStatus, data, host);
};
const bytype = (data) => {
    return outter_post(SystemDicApi.ByType, data, host);
};

const jhLIst = (data) => {
    return outter_post(SystemDicApi.JHLIst, data, host1);
};
const hlfLIst = (data) => {
    return outter_post(SystemDicApi.HLFLIst, data, host1);
};
const wtxLIst = (data) => {
    return outter_post(SystemDicApi.WTXLIst, data, host2);
};




export default {add,list,detail,checkUnique,update,dpStatus,bytype,jhLIst,hlfLIst,wtxLIst}



// WEBPACK FOOTER //
// ./src/service/SystemDicService.js